const SPELL_CHECK_ALLOWLIST: readonly string[] = [
  // CAD / dispatch
  'cad',
  'cfs',
  'eta',
  'tac',

  // Law enforcement
  'bolo',
  'apb',
  'aop',
  'bof',
  'leo',
  'ncic',
  'nlets',
  'uof',
  'ofc',

  // Units / specialised teams
  'ems',
  'eod',
  'erp',
  'hazmat',
  'mci',
  'swat',

  // Technology / systems
  'neris',
  'taser',

  // Vehicle / identity
  'mvd',
  'vic',
  'vin',
  'vpd',
] as const;

export default SPELL_CHECK_ALLOWLIST;
